import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { MainLayout } from "./components/Layout/MainLayout";
import { Toaster } from "sonner";

// Pages
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import UserProfile from "./pages/UserProfile";
import KYC from "./pages/KYC";
import WalletPayments from "./pages/WalletPayments";
import GameManagement from "./pages/GameManagement";
import Tournaments from "./pages/Tournaments";
import Bonuses from "./pages/Bonuses";
import FraudSecurity from "./pages/FraudSecurity";
import Support from "./pages/Support";
import Reports from "./pages/Reports";
import SystemSettings from "./pages/SystemSettings";
import AdminRoles from "./pages/AdminRoles";
import Countries from "./pages/Countries";
import RakeRevenue from "./pages/RakeRevenue";
import Referrals from "./pages/Referrals";
import Notifications from "./pages/Notifications";
import PaymentMethods from "./pages/PaymentMethods";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster 
          position="top-right" 
          toastOptions={{
            style: {
              background: 'hsl(240 10% 9%)',
              color: 'hsl(0 0% 98%)',
              border: '1px solid hsl(240 5.9% 17%)',
            },
          }}
        />
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          
          {/* Protected Routes */}
          <Route element={<MainLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/users" element={<Users />} />
            <Route path="/users/:userId" element={<UserProfile />} />
            <Route path="/kyc" element={<KYC />} />
            <Route path="/wallet" element={<WalletPayments />} />
            <Route path="/payments" element={<PaymentMethods />} />
            <Route path="/games" element={<GameManagement />} />
            <Route path="/tournaments" element={<Tournaments />} />
            <Route path="/bonuses" element={<Bonuses />} />
            <Route path="/fraud" element={<FraudSecurity />} />
            <Route path="/support" element={<Support />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/settings" element={<SystemSettings />} />
            <Route path="/admins" element={<AdminRoles />} />
            <Route path="/countries" element={<Countries />} />
            <Route path="/rake" element={<RakeRevenue />} />
            <Route path="/referrals" element={<Referrals />} />
            <Route path="/notifications" element={<Notifications />} />
          </Route>
          
          {/* Redirect root to dashboard */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          
          {/* 404 - Redirect to dashboard */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
